// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"169":"872a32cc","179":"92239100","351":"44de53d9","372":"267b784c","516":"42c4c7b7","582":"14c11731","682":"54e3b973","824":"7beb9f13"}[chunkId] + ".chunk.js";
};